import styled from 'styled-components'

export const CollapseHeader = styled.div`
    padding: 10px 16px;
    font-size: 14px;
    line-height: 16px;
    background: var(--color-gray-100);
`
